import React from 'react'

import styled from 'styled-components'
import { FadeLoader } from 'react-spinners'

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4;
  cursor: pointer;
`

const OverlayLoader = ({ isLoading }) =>
  isLoading ? (
    <Overlay>
      <FadeLoader
        sizeUnit={'px'}
        size={20}
        color={'white'}
        loading={isLoading}
      />
    </Overlay>
  ) : null

export default OverlayLoader



// WEBPACK FOOTER //
// ./src/components/OverlayLoader/index.js